// /Users/giovanny/euro-privilege-parceiros/frontend/src/components/admin/index.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import Dashboard from "./Dashboard";
import PartnerNew from "./PartnerNew";
import PartnersList from "./PartnersList";
import PartnerDetail from "./PartnerDetail";
import PartnerEdit from "./PartnerEdit";
// import AdminConsulta from "./AdminConsulta"; // removido
import AdminActivations from "./Activations";
import AdminActivationsList from "./ActivationsList";
import ScreensList from "./ScreensList";
import MidiasList from "./MidiasList";
import CampaignsList from "./CampaignsList";
import CondoNoticesList from "./CondoNoticesList";
import CondoUsersList from "./CondoUsersList";
import AuthAuditLogs from "./AuthAuditLogs";

/**
 * Rotas internas da área administrativa (/admin/*)
 */
export default function AdminRoutes() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />

        {/* Dashboard */}
        <Route path="dashboard" element={<Dashboard />} />

        {/* ✅ Consulta dentro do admin (mantém seu visual antigo) */}
        {/* <Route path="consulta" element={<AdminConsulta />} /> removido */}

        {/* Ativações */}
        <Route path="ativacoes" element={<AdminActivations />} />
        <Route path="ativacoes/lista" element={<AdminActivationsList />} />

        {/* Parceiros */}
        <Route path="partners" element={<PartnersList />} />
        <Route path="partners/new" element={<PartnerNew />} />
        <Route path="partners/:id" element={<PartnerDetail />} />
        <Route path="partners/:id/edit" element={<PartnerEdit />} />

        {/* Telas Indoor */}
        <Route path="screens" element={<ScreensList />} />
        <Route path="media-assets" element={<MidiasList />} />
        <Route path="campaigns" element={<CampaignsList />} />
        <Route path="condo-notices" element={<CondoNoticesList />} />
        <Route path="condo-users" element={<CondoUsersList />} />
        <Route path="auth-audit-logs" element={<AuthAuditLogs />} />
      </Route>
    </Routes>
  );
}
